<template>
    <div class="page-container">
        <div class="fixed-header">
            <div class="content-top">
                <div class="const-a">
                    <div class="content-top-left">
                        <img src="../assets/images/ap-1.png" alt="" @click="goToHome">
                    </div>
                    <!-- 顶部标题 -->
                    <div class="content-top-right">
                        <div class="text-a knowledge-points-title" :class="{ active: currentSubject === 'calculus' }"
                            @click="goToCalculusBC">
                            Calculus BC</div>
                        <div class="text-a" :class="{ active: currentSubject === 'microeconomics' }"
                            @click="goToMicroeconomics">Microeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'macroeconomics' }"
                            @click="goToMacroeconomics">Macroeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'physics' }" @click="goToPhysics1">
                            Physics1</div>
                        <div class="text-a" :class="{ active: currentSubject === 'biology' }" @click="goToBiology">
                            Biology</div>
                        <div class="text-a" :class="{ active: currentSubject === 'csp' }" @click="goToCSP">CSP</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scrollable-content">
            <HelloWorld :title="subjectTitles[currentSubject]" :background-color="subjectColors[currentSubject]"
                :subject="currentSubject" />
            <div class="nav-container">
                <div class="nav">
                    <div class="two">
                        <div v-for="(tab, index) in tabs" :key="index" class="tab-item"
                            :class="{ active: activeTab === index }" @click="switchTab(index)"
                            @mouseenter="hoveredTab = index" @mouseleave="hoveredTab = null">
                            <span :class="{ 'tab-name': true, 'active-name': activeTab === index }">{{ tab.name
                            }}</span>
                            <div v-if="activeTab === index || hoveredTab === index" class="triangle"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 根据当前激活的 tab 显示不同的内容 -->
            <!-- Past year papers (index 0) -->
            <!-- Past year papers (index 0) -->

            <div v-if="activeTab === 0 && tabData.length > 0" class="y-height">
                <div class="nav-container-ll">
                    <div class="nav-containers">
                        <div class="navs">
                            <div class=" horizontal-scroll-container">
                                <div class="fixed-options">
                                    <div class="n-c">
                                        Year
                                    </div>
                                    <div class="n-d" :class="{ active: selectedYear === '' }" @click="selectYear('')">
                                        All
                                    </div>
                                </div>

                                <div class="scroll-wrapper">
                                    <div class="scroll-content">

                                        <div v-for="(item, index) in tabData[0].lists" :key="index" class="n-f"
                                            :class="{ active: selectedYear === item.typeName }"
                                            @click="selectYear(item.typeName)">
                                            {{ item.typeName }}
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Past year papers 列表 -->
                    <div class="nav-container-s">
                        <div class="nav">
                            <!-- 添加加载状态指示器 -->
                            <div v-if="loading" class="loading-container">
                                <div class="spinner"></div>
                                <p>Loading...</p>
                            </div>



                            <!-- 数据内容 -->
                            <div v-show="!loading" class="box-row-f-wrapper" style="height: 900px;">
                                <div class="box-row-f">
                                    <div v-for="(item, index) in questionList" :key="index" class="box1-wrapper3"
                                        @click="goToDetail(item)">
                                        <div class="box-left">
                                            <!-- <img src="../assets/images/tiku-img.png" alt=""> -->
                                            <img :src="imgurl + item.questionImage" alt="">
                                            <!-- <embed :src="item.questionAddress" type="application/pdf" width="100%" height="150px" v-if="item.questionAddress"> -->
                                        </div>
                                        <div class="box-right">
                                            <div class="box-text-top">
                                                {{ item.questionName || '暂无数据' }}
                                                <br />
                                                <!-- {{ item.questionNotes  || 'This is the description' }} -->
                                            </div>
                                            <div class="box-text-bottom">
                                                <text>
                                                    View details
                                                </text>
                                                <img src="../assets/images/Vector.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- 在 logo-a-g 之前添加分页控件 -->
                            <div v-show="!loading" class="pagination-container">
                                <div class="pagination-controls">
                                    <button :disabled="!pagination.hasPreviousPage" @click="goToPreviousPage"
                                        class="pagination-btn">
                                        <!-- 上一页 -->
                                        ←
                                    </button>

                                    <span class="pagination-info">
                                        <!-- 第 {{ pagination.pageNum }} 页，共 {{ Math.ceil(pagination.total / pagination.pageSize) }} 页 -->
                                        |
                                    </span>

                                    <button :disabled="!pagination.hasNextPage" @click="loadMore"
                                        class="pagination-btn">
                                        <!-- 下一页 -->
                                        →
                                    </button>
                                </div>
                            </div>

                            <!-- 
                            <div v-show="!loading" class="logo-a-g">
                                <Arrowhead />
                            </div> -->












                        </div>
                    </div>

                </div>

            </div>

            <!-- Difficulty (index 1) -->
            <!-- Difficulty (index 1) -->
            <div v-else-if="activeTab === 1 && tabData.length > 1" class="y-height">
                <div class="nav-container-ll">

                    <div class="nav-containers">
                        <div class="navs ">
                            <div class=" horizontal-scroll-container">
                                <!-- <div class="nav-title"> -->
                                <div class="fixed-options">
                                    <div class="nav-title-a-p">
                                        Difficulty
                                    </div>
                                    <div class="nav-title-b" :class="{ active: selectedDifficulty === '' }"
                                        @click="selectDifficulty('')">All
                                    </div>
                                </div>

                                <div class="scroll-wrapper">
                                    <div class="scroll-content">

                                        <div v-for="(item, index) in tabData[1].lists" :key="index" class="nav-title-c"
                                            :class="{ active: selectedDifficulty === item.typeName }"
                                            @click="selectDifficulty(item.typeName)">
                                            {{ item.typeName }}
                                        </div>
                                        <!-- </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                    <!-- Difficulty 列表 -->
                    <div class="nav-container-s">
                        <div class="nav">

                            <!-- 添加加载状态指示器 -->
                            <div v-if="loading" class="loading-container">
                                <div class="spinner"></div>
                                <p>Loading...</p>
                            </div>

                            <!-- 数据内容 -->


                            <div v-show="!loading" class="box-row-f-wrapper">
                                <div class="box-row-f">
                                    <div v-for="(item, index) in questionList" :key="index" class="box1-wrapper3"
                                        @click="goToDetail(item)">
                                        <div class="box-left">
                                            <!-- <img src="../assets/images/tiku-img.png" alt=""> -->
                                            <img :src="imgurl + item.questionImage" alt="">
                                        </div>
                                        <div class="box-right">
                                            <div class="box-text-top">
                                                {{ item.questionName || 'This is the title of the question bank' }}
                                                <br />
                                                <!-- {{ item.description || 'This is the description' }} -->
                                            </div>
                                            <div class="box-text-bottom">
                                                <text>
                                                    View details
                                                </text>
                                                <img src="../assets/images/Vector.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div v-show="!loading" class="pagination-container">
                                <div class="pagination-controls">
                                    <button :disabled="!pagination.hasPreviousPage" @click="goToPreviousPage"
                                        class="pagination-btn">
                                        <!-- 上一页 -->
                                        ←
                                    </button>

                                    <span class="pagination-info">
                                        <!-- 第 {{ pagination.pageNum }} 页，共 {{ Math.ceil(pagination.total / pagination.pageSize) }} 页 -->
                                        |
                                    </span>

                                    <button :disabled="!pagination.hasNextPage" @click="loadMore"
                                        class="pagination-btn">
                                        <!-- 下一页 -->
                                        →
                                    </button>
                                </div>
                            </div>










                            <!-- <div v-show="!loading" class="logo-a-g">
                                <Arrowhead />
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>

            <!-- Knowledge points (index 2) -->
            <!-- Knowledge points (index 2) -->
            <div v-else-if="activeTab === 2 && tabData.length > 2" class="y-height">
                <div class="nav-container-ll">
                    <div class="nav-containers">
                        <div class="navs">
                            <div class=" horizontal-scroll-container">
                                <!-- <div class="nav-title"> -->
                                <div class="fixed-options">
                                    <div class="nav-title-a knowledge-points-title">
                                        Knowledge Points
                                    </div>
                                    <div class="nav-title-b" :class="{ active: selectedKnowledge === '' }"
                                        @click="selectKnowledge('')">All</div>
                                </div>
                                <div class="scroll-wrapper">
                                    <div class="scroll-content">

                                        <div v-for="(item, index) in tabData[2].lists" :key="index"
                                            class="nav-title-c-y"
                                            :class="{ active: selectedKnowledge === item.typeName }"
                                            @click="selectKnowledge(item.typeName)">
                                            {{ item.typeName }}
                                        </div>

                                        <!-- </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Knowledge points PDF列表 -->
                    <div class="nav-container-s">
                        <div class="nav">

                            <!-- 添加加载状态指示器 -->
                            <div v-if="loading" class="loading-container">
                                <div class="spinner"></div>
                                <p>Loading...</p>
                            </div>

                            <!-- 数据内容 -->


                            <div v-show="!loading" class="box-row-f-wrapper">
                                <div class="box-row-f">
                                    <div v-for="(item, index) in questionList" :key="index" class="box1-wrapper3"
                                        @click="goToDetail(item)">
                                        <div class="box-left">
                                            <!-- <img src="../assets/images/tiku-img.png" alt=""> -->
                                            <img :src="imgurl + item.questionImage" alt="">
                                        </div>
                                        <div class="box-right">
                                            <div class="box-text-top">
                                                {{ item.questionName || '暂无数据' }}
                                                <br />
                                                <!-- {{ item.questionNotes || 'This is the description' }} -->
                                            </div>
                                            <div class="box-text-bottom">
                                                <text>
                                                    View details
                                                </text>
                                                <img src="../assets/images/Vector.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>




                            <div v-show="!loading" class="pagination-container">
                                <div class="pagination-controls">
                                    <button :disabled="!pagination.hasPreviousPage" @click="goToPreviousPage"
                                        class="pagination-btn">
                                        <!-- 上一页 -->
                                        ←
                                    </button>

                                    <span class="pagination-info">
                                        <!-- 第 {{ pagination.pageNum }} 页，共 {{ Math.ceil(pagination.total / pagination.pageSize) }} 页 -->
                                        |
                                    </span>

                                    <button :disabled="!pagination.hasNextPage" @click="loadMore"
                                        class="pagination-btn">
                                        <!-- 下一页 -->
                                        →
                                    </button>
                                </div>
                            </div>






                            <!-- <div v-show="!loading" class="logo-a-g">
                                <Arrowhead />
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- Video & Notes (index 3) -->
            <!-- Video & Notes (index 3) -->
            <div v-else-if="activeTab === 3 && tabData.length > 3" class="y-height">
                <div class="nav-container-ll">
                    <!-- Video & Notes 列表 -->
                    <div class="nav-container">
                        <div class="nav">
                            <!-- 添加加载状态指示器 -->
                            <div v-if="loading" class="loading-container">
                                <div class="spinner"></div>
                                <p>Loading...</p>
                            </div>
                            <!-- 数据内容 -->
                            <div v-show="!loading" class="box-row-wrapper">
                                <div class="box-row" style="max-height: 900px;">
                                    <div v-for="(item, index) in questionList" :key="index" class="box1-wrapper2"
                                        @click="goToVideoDetail(item)">
                                        <div class="box1-b">
                                            <!-- 使用导入的视频源 -->
                                            <!-- <video :src="imgurl + item.questionAddress" controls muted preload="metadata"
                                        width="100%" height="100%" style="border-radius: 12px; object-fit: cover;">
                                        您的浏览器不支持视频播放。
                                    </video> -->
                                            <!-- 根据questionType显示不同内容 -->
                                            <!-- questionType为1时显示PDF -->
                                            <div v-if="item.questionType === '1'" class="pdf-container">
                                                <embed :src="imgurl + item.questionAddress" type="application/pdf"
                                                    width="100%" height="600px" style="border-radius: 12px;">
                                                <p v-if="!questionAddress">暂无PDF文件</p>
                                            </div>

                                            <!-- questionType为2时显示视频 -->
                                            <div v-else-if="item.questionType === '2'" class="video-container">
                                                <video :src="imgurl + item.questionAddress" controls muted
                                                    preload="metadata" style="border-radius: 12px; object-fit: cover;">
                                                    您的浏览器不支持视频播放。
                                                </video>
                                            </div>
                                            <!-- questionType为3时显示富文本 -->
                                            <div v-else-if="item.questionType === '3'" class="rich-text-container"
                                                v-html="item.questionNotes">
                                            </div>

                                            <!-- 其他情况显示默认内容 -->
                                            <div v-else>
                                                <p>暂不支持的文件类型</p>
                                            </div>
                                        </div>
                                        <div class="box2-b">
                                            <text>
                                                {{ item.questionName || '暂无数据' }}
                                                <br>

                                            </text>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-show="!loading" class="pagination-container">
                                <div class="pagination-controls">
                                    <button :disabled="!pagination.hasPreviousPage" @click="goToPreviousPage"
                                        class="pagination-btn">
                                        <!-- 上一页 -->
                                        ←
                                    </button>

                                    <span class="pagination-info">
                                        <!-- 第 {{ pagination.pageNum }} 页，共 {{ Math.ceil(pagination.total / pagination.pageSize) }} 页 -->
                                        |
                                    </span>

                                    <button :disabled="!pagination.hasNextPage" @click="loadMore"
                                        class="pagination-btn">
                                        <!-- 下一页 -->
                                        →
                                    </button>
                                </div>
                            </div>





                            <!-- <div v-show="!loading" class="logo-a-g">
                                <Arrowhead />
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Concat v-if="setShow" />
    </div>
</template>

<script setup>
import Arrowhead from '../components/Arrowhead.vue'
import { useRouter, useRoute } from 'vue-router';
import Concat from '../components/Concat.vue'
import HelloWorld from '@/components/HelloWorld.vue';
import { ref, computed, onMounted, watch } from 'vue'
import videoSource from '../assets/videos/video.mp4'
import { getHomeData, getQuestionList } from '@/api/modules/home.js'
// import DOMPurify from 'dompurify'

// // 创建一个计算属性来净化富文本内容
// const sanitizeHtml = (html) => {
//   return DOMPurify.sanitize(html)
// }

// 添加loading状态
const loading = ref(false)
const imgurl = 'https://question-bank-hao.obs.cn-southwest-2.myhuaweicloud.com'


const router = useRouter()
const route = useRoute()

// 当前激活的 tab
const activeTab = ref(0)

// 当前悬停的tab
const hoveredTab = ref(null)

// 当前学科
const currentSubject = ref('calculus')

// 标签页数据
const tabData = ref([])

// 题库列表数据
const questionList = ref([])

// 选中的年份
const selectedYear = ref('')

// 选中的难度
const selectedDifficulty = ref('')

// 选中的知识点
const selectedKnowledge = ref('')
const setShow = ref(false)
// 学科标题映射
const subjectTitles = {
    calculus: 'Calculus BC',
    microeconomics: 'Microeconomics',
    macroeconomics: 'Macroeconomics',
    physics: 'Physics1',
    biology: 'Biology',
    csp: 'CSP'
}

// 学科颜色映射
const subjectColors = {
    calculus: '#3676FF',
    microeconomics: '#FF9500',
    macroeconomics: '#F6621F',
    physics: '#55BA54',
    biology: '#FB585B',
    csp: '#40A4D8'
}






// 监听路由参数变化
watch(() => route.query.subject, (newSubject) => {
    if (newSubject) {
        currentSubject.value = newSubject
    }
}, { immediate: true })

// 监听路由参数中的tab变化
watch(() => route.query.tab, (newTab) => {
    if (newTab !== undefined) {
        activeTab.value = parseInt(newTab)
    }
}, { immediate: true })

// 监听路由参数中的option变化
watch(() => route.query.option, (newOption) => {
    if (newOption !== undefined) {
        // 根据当前激活的tab更新相应的选项
        switch (activeTab.value) {
            case 0: // Past year papers
                selectedYear.value = newOption
                break
            case 1: // Difficulty
                selectedDifficulty.value = newOption
                break
            case 2: // Knowledge points
                selectedKnowledge.value = newOption
                break
        }
    } else {
        // 如果没有option参数，重置选择
        selectedYear.value = ''
        selectedDifficulty.value = ''
        selectedKnowledge.value = ''
    }
}, { immediate: true })

// 定义 tabs
const tabs = ref([
    { name: 'Past year papers', path: '/microeconomics' },
    { name: 'Difficulty', path: '/microeconomics' },
    { name: 'Knowledge points', path: '/physics1' },
    { name: 'Video & Notes', path: '/physics1' }
])

// 学科映射
const subjectMap = {
    calculus: 'Calculus BC',
    microeconomics: 'Microeconomics',
    macroeconomics: 'Macroeconomics',
    physics: 'Physics1',
    biology: 'Biology',
    csp: 'CSP'
}

// 根据选中年份获取PDF列表
const getPdfListByYear = computed(() => {
    // 这里应该从实际数据中获取PDF列表，目前使用模拟数据
    if (selectedYear.value === '' || selectedYear.value === 'All') {
        // 返回所有年份的PDF列表
        return Array.from({ length: 10 }, (_, i) => ({
            title: `AP Calculus BC ${2025 - i} Question Paper`,
            description: `Full solutions for ${2025 - i} exam`
        }))
    } else {
        // 返回特定年份的PDF列表
        return Array.from({ length: 5 }, (_, i) => ({
            title: `AP Calculus BC ${selectedYear.value} Question Paper - Set ${i + 1}`,
            description: `Detailed solutions for ${selectedYear.value} exam set ${i + 1}`
        }))
    }
})

// 根据选中难度获取PDF列表
const getPdfListByDifficulty = computed(() => {
    // 这里应该从实际数据中获取PDF列表，目前使用模拟数据
    if (selectedDifficulty.value === '' || selectedDifficulty.value === 'All') {
        // 返回所有难度的PDF列表
        return Array.from({ length: 10 }, (_, i) => ({
            title: `Calculus Practice Questions - Set ${i + 1}`,
            description: `Mixed difficulty practice set ${i + 1}`
        }))
    } else {
        // 返回特定难度的PDF列表
        return Array.from({ length: 5 }, (_, i) => ({
            title: `${selectedDifficulty.value} Calculus Questions - Set ${i + 1}`,
            description: `Practice set ${i + 1} for ${selectedDifficulty.value} level`
        }))
    }
})

// 获取题库类型数据
const fetchHomeData = async () => {
    try {
        const res = await getHomeData()
        console.log('类型列表999999', res.data)
        tabData.value = res.data
        setShow.value = true
    } catch (error) {
        console.error('类型列表失败33:', error)
        if (error.message.includes('Network Error')) {
            console.error('网络连接错误，请检查服务器是否运行正常')
        }
    }

}



// 添加分页相关状态
const pagination = ref({
    pageNum: 1,
    pageSize: 10,
    total: 0,
    hasNextPage: false,
    hasPreviousPage: false
})


// 修改获取题库列表数据的方法
const fetchQuestionList = async (pageNum = 1, isLoadMore = false) => {
    try {
        // 开始加载
        loading.value = true

        // 更新页码
        if (!isLoadMore) {
            pagination.value.pageNum = pageNum
        }

        // 构造参数
        const params = {
            pageNum: pagination.value.pageNum,
            pageSize: pagination.value.pageSize,
            subjectName: subjectMap[currentSubject.value] || 'Calculus BC',
            typeName: tabs.value[activeTab.value]?.name || 'Past year papers',
            subclassName: activeTab.value === 0
                ? (selectedYear.value === 'All' ? '' : selectedYear.value)
                : activeTab.value === 1
                    ? (selectedDifficulty.value === 'All' ? '' : selectedDifficulty.value)
                    : activeTab.value === 2
                        ? (selectedKnowledge.value === 'All' ? '' : selectedKnowledge.value)
                        : ''
        }

        console.log('请求参数:', params)

        const res = await getQuestionList(params)
        console.log('题库列表666', res.data)

        // 更新分页信息
        if (res.data.pageNum && res.data.pageSize && res.data.total) {
            pagination.value = {
                pageNum: res.data.pageNum,
                pageSize: res.data.pageSize,
                total: res.data.total,
                hasNextPage: res.data.pageNum * res.data.pageSize < res.data.total,
                hasPreviousPage: res.data.pageNum > 1
            }

            // 更新数据列表
            questionList.value = res.data.list || res.data || []
        } else {
            questionList.value = res.data.list || res.data || []
            // 如果没有分页信息，根据数据长度判断是否有下一页
            pagination.value.hasNextPage = questionList.value.length >= pagination.value.pageSize
            pagination.value.hasPreviousPage = pagination.value.pageNum > 1
        }
    } catch (error) {
        console.error('题库列表失败:', error)
        questionList.value = []
        pagination.value.hasNextPage = false
        pagination.value.hasPreviousPage = pagination.value.pageNum > 1
        if (error.message.includes('Network Error')) {
            console.error('网络连接错误，请检查服务器是否运行正常')
        }
    } finally {
        // 加载完成
        loading.value = false
    }
}

// 添加分页方法
const loadMore = () => {
    if (pagination.value.hasNextPage) {
        fetchQuestionList(pagination.value.pageNum + 1)
    }
}

const goToPreviousPage = () => {
    if (pagination.value.hasPreviousPage) {
        fetchQuestionList(pagination.value.pageNum - 1)
    }
}







// 切换 tab
const switchTab = (index) => {
    activeTab.value = index
    // 更新路由参数
    router.push({
        path: route.path,
        query: {
            ...route.query,
            tab: index,
            option: undefined // 切换tab时清除option参数
        }
    })
}

// 选择年份
const selectYear = (year) => {
    selectedYear.value = year
}

// 选择难度
const selectDifficulty = (difficulty) => {
    selectedDifficulty.value = difficulty
}
// 选择知识点
const selectKnowledge = (knowledge) => {
    selectedKnowledge.value = knowledge
}


// 跳转到 PDF 详情页
function goToDetail(item) {
    router.push({
        path: "/Detail-pdf",
        query: {
            id: item.id,
            questionAddress: item.questionAddress,
            questionImage: item.questionImage,
            questionName: item.questionName,
            questionNotes: item.questionNotes,
            questionType: item.questionType
        }
    });
}

// 跳转到视频详情页
const goToVideoDetail = (item) => {
    router.push({
        path: "/videosd",
        query: {
            // item: JSON.stringify(item)
            id: item.id,
            questionAddress: item.questionAddress,
            questionImage: item.questionImage,
            questionName: item.questionName,
            questionNotes: item.questionNotes,
            questionType: item.questionType
        }
    });
}

// 页面导航函数
const goToHome = () => {
    router.push('/')
}

const goToMicroeconomics = () => {
    currentSubject.value = 'microeconomics'
}

const goToBiology = () => {
    currentSubject.value = 'biology'
}

const goToPhysics1 = () => {
    currentSubject.value = 'physics'
}

const goToCSP = () => {
    currentSubject.value = 'csp'
}

const goToMacroeconomics = () => {
    currentSubject.value = 'macroeconomics'
}

const goToCalculusBC = () => {
    currentSubject.value = 'calculus'
}

// 组件挂载时获取数据
onMounted(() => {
    fetchHomeData()
})

// 监听学科、tab、年份、难度或知识点的变化，重新获取题库列表（第一页）
watch([currentSubject, activeTab, selectedYear, selectedDifficulty, selectedKnowledge], () => {
    fetchQuestionList(1)//重置到第一页
}, { immediate: true })
</script>

<style>
/* 横向滚动容器样式 */
.horizontal-scroll-container {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
}

.fixed-options {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 15px;
}

.scroll-wrapper {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    flex: 1;
    position: relative;
    padding: 5px 0;
}

/* 自定义滚动条样式 */
.scroll-wrapper::-webkit-scrollbar {
    height: 8px;
}

.scroll-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.scroll-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.scroll-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.scroll-content {
    display: inline-flex;
    gap: 12px;
    padding: 2px 5px;
}

/* 通用选项样式 */
.n-f,
.nav-title-c,
.nav-title-c-y {
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 20px;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    min-width: max-content;
    color: #333;
    font-size: 14px;
}

.n-f.active,
.nav-title-c.active,
.nav-title-c-y.active {
    background-color: #000000;
    color: #ffffff;
    font-weight: bold;
}

/* All选项样式 */
.n-d,
.nav-title-b {
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 20px;
    transition: all 0.3s ease;
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
    color: #333;
    font-size: 14px;
    white-space: nowrap;
    margin-left: 15px;
}

.n-d.active,
.nav-title-b.active {
    background-color: #000000;
    color: #ffffff;
    font-weight: bold;
    border-color: #000000;
}

/* 标题样式 */
.n-c,
.nav-title-a-p,
.nav-title-a {
    font-weight: bold;
    font-size: 16px;
    color: #333;
    margin-right: 15px;
    white-space: nowrap;
}

/* 悬停效果增强 */
.n-f:hover,
.nav-title-c:hover,
.nav-title-c-y:hover,
.n-d:hover,
.nav-title-b:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
    .horizontal-scroll-container {
        flex-direction: column;
        align-items: flex-start;
    }

    .fixed-options {
        width: 100%;
        justify-content: space-between;
        margin-bottom: 10px;
        margin-right: 0;
    }

    .scroll-wrapper {
        width: 100%;
    }
}












/* 添加分页控件样式 */
.pagination-container {
    /* border: 1px solid red; */
    width: 1200px;
    display: flex;
    justify-content: flex-end;
    /* 改为右对齐 */
    /* margin: 20px 117px;
    padding-right: 120px; */
    /* 与列表右边对齐 */
}

.pagination-controls {
    display: flex;
    align-items: center;
    gap: 20px;
}

.pagination-btn {
    padding: 8px 16px;
    /* background-color: #f0f0f0; 移除背景颜色 */
    /* border: 1px solid #ddd; 移除边框 */
    border: none;
    background: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 38px;
    /* 放大2倍 (从16px到32px) */
    font-weight: bold;
    color: #333;
}

.pagination-btn:hover:not(:disabled) {
    /* background-color: #e0e0e0; 移除悬停背景颜色 */
    color: #000;
}

.pagination-btn:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.pagination-separator {
    font-size: 32px;
    /* 放大2倍 (从20px到32px) */
    font-weight: bold;
    color: #666;
}

.pagination-info {
    font-size: 32px;
    /* 放大2倍 (从20px到32px) */
}

/* ... 其他样式保持不变 ... */
.box-row-f-wrapper {
    width: 100%;
    min-height: 900px;
    margin-bottom: 20px;
}

.box-row-wrapper {
    width: 100%;
    min-height: 1021px;
    margin-bottom: 20px;
}





.video-container,
.rich-text-container {
    width: 380px;
    height: 214px;
    background: #F9F9F9;
    border: 1px solid #F9F9F9;
    border-radius: 12px 12px 12px 12px;
}

.video-container video {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    object-fit: cover;
}

.rich-text-container {
    border-radius: 12px;
    overflow: auto;
}

/* 覆盖富文本内容中的居中样式 */
.rich-text-container * {
    text-align: left !important;
    padding: 3px;
}




/* .nav-title-c-y {
    width: 107px;
    height: 22px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    text-align: left;
}

.nav-title-c-y.active {
    font-weight: bold;
    text-decoration: underline;
} */

.nav-title-a-p {
    width: 85px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-right: 20px;
}

.knowledge-points-title {
    white-space: nowrap;
}

.page-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background-color: black;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.content-top {
    width: 100vw;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.const-a {
    width: 1200px;
    height: 100px;
    display: flex;
    align-items: center;
}

.content-top-left {
    width: 202px;
    height: 44px;
    margin-right: 108px;
}

.content-top-left img {
    width: 202px;
    height: 44px;
    cursor: pointer;
}

.content-top-right {
    width: 890px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.text-a {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    margin-right: 39px;
    cursor: pointer;
    white-space: nowrap;
}

.text-a.active {
    text-decoration: underline;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    margin-top: 100px; /* 等于头部高度，防止内容被遮挡 */
    padding-top: 20px; /* 可选：添加一些顶部间距 */
}

/* .fixed-footer {
    flex-shrink: 0;
} */

/* 2222222 */
/* .nav-container {
    width: 100vw;
    display: flex;
    justify-content: center;
} */

/* .nav {
    width: 1200px;
    margin: 0px 120px 0px 120px;
    border-top: 1px solid;
} */

.two {
    width: 100%;
    height: 64px;
    background: #000000;
    border-radius: 0px 0px 0px 0px;
    display: flex;
}

.tab-item {
    margin: 20px 0px 19px 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    text-align: left;
    cursor: pointer;
    padding: 0 10px;
    transition: all 0.3s ease;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.tab-item:first-child {
    margin-left: 24px;
}

.tab-item:not(:first-child) {
    margin-left: 155px;
}

.tab-item:hover {
    opacity: 0.8;
}

.tab-name {
    white-space: nowrap;
}

.tab-name.active-name {
    font-weight: 800;
}

.triangle {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 10px solid white;
    margin-top: 8px;
}

/* .n-d,
.n-f,
.nav-title-b,
.nav-title-c {
    cursor: pointer;


}

.n-d.active,
.n-f.active,
.nav-title-b.active,
.nav-title-c.active {
    font-weight: bold;
    text-decoration: underline;
} */
.nav-title-b {
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.nav-title-b.active {
    background-color: #000000;
    color: #ffffff;
    font-weight: bold;
}

.n-d,
.n-f,
.nav-title-b,
.nav-title-c,
.nav-title-c-y {
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.n-d.active,
.n-f.active,
.nav-title-b.active,
.nav-title-c.active,
.nav-title-c-y.active {
    background-color: #000000;
    color: #ffffff;
    font-weight: bold;
}

.nav-container-s {
    width: 100vw;
    display: flex;
    justify-content: center;
    border-top: none;
    /* 去掉顶部的黑线 */
}



@import '../pages/index-c.css'
</style>